<template>
  <DashboardVideo />
  <div class="container d-flex align-items-center justify-content-center z-2">
    <div class="row mobile align-content-between g-0">
      <TypeTopNav
        :heading="this.assetType"
        :routeBack="{
          name: 'AssetList',
          params: {
            assetType: this.assetType,
            viewType: this.viewType,
          },
        }"
      />
      <div class="col-12 d-flex align-items-center justify-content-center z-2">
        <div class="row g-0">
          <div class="col-12">
            <router-link
              v-for="(assetType, index) in assetTypes"
              :key="assetType.Guid"
              :to="{
                name: 'AssetViewDetail',
                params: {
                  assetType: this.assetType,
                  viewType: this.viewType,
                  order: 5 + index,
                },
              }"
              :class="['btn-theme-menu', 'mb-2']"
            >
              {{ formatTitle(assetType.ObjectName) }}
            </router-link>
          </div>
        </div>
      </div>
      <div
        class="col-12 d-flex align-items-end justify-content-end sticky-bottom theme-footer"
      ></div>
    </div>
  </div>
  <OffCanvas />
</template>

<script>
import DashboardVideo from "@/components/DashboardVideo.vue";
import OffCanvas from "@/components/OffCanvas.vue";
import TypeTopNav from "@/components/TypeTopNav.vue";
import global from "../global";
import BunnyNetService from "@/services/BunnyNetService.js";
import { unslugify } from "unslugify";
import sortArray from "sort-array";

export default {
  name: "AssetList",
  components: {
    DashboardVideo,
    OffCanvas,
    TypeTopNav,
  },
  props: ["assetType", "viewType", "type"],

  data() {
    return {
      assetTypes: null,
      componentName: "AssetType",
      folderStructure: encodeURIComponent(
        this.theme.devFolder +
          "/types/" +
          this.assetType +
          "/" +
          this.viewType +
          "/" +
          this.type +
          "/"
      ),
    };
  },
  created() {
    BunnyNetService.getFolders(this.folderStructure)
      .then((response) => {
        // Remap array
        const menuItems = response.data.map((item) => {
          return {
            Guid: item.Guid,
            ObjectName: unslugify(item.ObjectName),
            LinkName: item.ObjectName,
            ComponentName: this.componentName,
            Path: item.Path,
            IsDirectory: item.IsDirectory,
            StorageZoneName: item.StorageZoneName,
          };
        });

        const customMenu = sortArray(menuItems, {
          by: ["LinkName"],
          order: "LinkName",
          customOrders: {
            LinkName: this.theme.balconyMenuOrder,
          },
        });

        this.assetTypes = customMenu;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  methods: {
    formatTitle: function (title) {
      return title.replace("Da", "DA");
    },
  },
  setup() {
    const { theme } = global;

    return {
      theme,
    };
  },
};
</script>
